// Confirm
export const CONFIRM_YES = 'core/CONFIRM_YES';
export const CONFIRM_NO = 'core/CONFIRM_NO';

export const SERVER_ERROR = 'core/SERVER_ERROR';
export const SET_DOWNLOAD_PROGRESS = 'core/SET_DOWNLOAD_PROGRESS';